import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { VerticalStack, HorizontalStack } from './Stack';
import { SectionEyebrow } from './Typography';

export interface PaneSectionProps {
  label: string;
  icon?: LucideIcon;
  children: React.ReactNode;
  className?: string;
}

export function PaneSection({
  label,
  icon: Icon,
  children,
  className,
}: PaneSectionProps) {
  return (
    <VerticalStack gap={3} className={className}>
      <HorizontalStack gap={2} className="text-muted-foreground">
        {Icon && <Icon className="h-3.5 w-3.5" />}
        <SectionEyebrow>{label}</SectionEyebrow>
      </HorizontalStack>
      <div className="px-0.5">{children}</div>
    </VerticalStack>
  );
}
